import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const DevKeyDetails = ({devKey}) => {

  return (
    <Fragment>
      <ul>
        <li>
          <b>App ID:</b> {devKey ? devKey.appId : 'Not set'}
        </li>
        <li>
          <b>App Key:</b> {devKey ? devKey.appKey : 'Not set'}
        </li>
      </ul>
    </Fragment>
  )
}

DevKeyDetails.propTypes = {
  devKey: PropTypes.object,
}

export default DevKeyDetails
